const styles = theme => ({
  buttonGroup: {
    '&:not(:last-child)': {
      marginRight: '10px',
    },
  },
})

export default styles
